<div class="deviation-header oneline">

  <div class="header-inline">

    <div class="footer-left">
    <!-- Title -->
    <span class="deviation-title">{{ titleText }}</span>

    <span class="deviation-for" *ngIf="deviationFor">
      <span class="highlight"> - {{ deviationFor }}</span>
    </span>
    </div>

    <!-- Context Chips -->
     <div class="footer-right">
    <span
      class="context-chip"
      *ngFor="let item of headerContext"
    >
      <span class="chip-label">{{ item.label }}</span> : 
      <span class="chip-value">{{ item.value }}</span>
    </span>
    </div>

  </div>

</div>




<form [formGroup]="deviationForm" class="deviation-form">
  <mat-horizontal-stepper
   [linear]="true" 
    #stepper
    (selectionChange)="onStepChange($event)"
  >
    <!-- ================= STEP 1 ================= -->
    <mat-step label="Deviation Details" [stepControl]="deviationForm">
      <!-- Row 1 : Deviation Object + Title + Type -->
      <div class="form-row four-col-row">
        <!-- TOP LEVEL CONTROL -->
        <mat-form-field appearance="outline">
          <mat-label>Select Deviation Object Type</mat-label>
          <mat-select formControlName="deviationObjectType">
            <mat-option
              *ngFor="let dt of deviationObjectType"
              [value]="dt.lookupvalue"
            >
              {{ dt.lookupvalue }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              deviationForm.get('deviationObjectType')?.hasError('required')
            "
          >
            Deviation Object Type is required
          </mat-error>
        </mat-form-field>

        <!-- GROUP START -->
        <div formGroupName="deviationDetails" class="form-row-inner">
          <mat-form-field appearance="outline">
            <mat-label>Deviation Title</mat-label>
            <input matInput formControlName="title" />
            <mat-error
              *ngIf="
                deviationForm
                  .get('deviationDetails.title')
                  ?.hasError('required')
              "
            >
              Title is required
            </mat-error>
            <mat-error *ngIf=" deviationForm
                .get('deviationDetails.title')?.hasError('specialCharacter')">
            Special characters are not allowed
           </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Deviation Type</mat-label>
            <mat-select formControlName="deviationType">
              <mat-option
                *ngFor="let dt of deviationType"
                [value]="dt.lookupvalue"
              >
                {{ dt.lookupvalue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                deviationForm
                  .get('deviationDetails.deviationType')
                  ?.hasError('required')
              "
            >
              Deviation type is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Rating</mat-label>
            <mat-select formControlName="rating">
              <mat-option *ngFor="let dt of rating" [value]="dt.lookupvalue">
                {{ dt.lookupvalue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                deviationForm
                  .get('deviationDetails.rating')
                  ?.hasError('required')
              "
            >
              Rating is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Row 2 : Dates + Department + Facility -->
      <div formGroupName="deviationDetails" class="form-row four-col-row">
        <mat-form-field appearance="outline">
          <mat-label>Occurrence Date</mat-label>
          <input
            matInput
            [matDatepicker]="occPicker"
            formControlName="occurrenceDate"
            readonly
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="occPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #occPicker></mat-datepicker>
          <mat-error
            *ngIf="
              deviationForm
                .get('deviationDetails.occurrenceDate')
                ?.hasError('required')
            "
          >
            Occurrence Date is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Awareness Date</mat-label>
          <input
            matInput
            [matDatepicker]="awarePicker"
            formControlName="awarenessDate"
            readonly
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="awarePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #awarePicker></mat-datepicker>
          <mat-error
            *ngIf="
              deviationForm
                .get('deviationDetails.awarenessDate')
                ?.hasError('required')
            "
          >
            Awareness Date is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Owning Department</mat-label>
          <mat-select formControlName="owningDepartment">
            <mat-option
              *ngFor="let dt of owningDepartment"
              [value]="dt.lookupvalue"
            >
              {{ dt.lookupvalue }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              deviationForm
                .get('deviationDetails.owningDepartment')
                ?.hasError('required')
            "
          >
            Owning Department is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Owning Facility</mat-label>
          <mat-select formControlName="owningFacility">
            <mat-option
              *ngFor="let dt of owningFacility"
              [value]="dt.lookupvalue"
            >
              {{ dt.lookupvalue }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              deviationForm
                .get('deviationDetails.owningFacility')
                ?.hasError('required')
            "
          >
            Owning Facility is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Row 3 : Description + Corrective Action -->
      <div formGroupName="deviationDetails" class="form-row three-col-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" rows="4"></textarea>
          <mat-error
            *ngIf="
              deviationForm
                .get('deviationDetails.description')
                ?.hasError('required')
            "
          >
            Description is required
          </mat-error>
          <mat-error *ngIf=" deviationForm
                .get('deviationDetails.description')?.hasError('specialCharacter')">
            Special characters are not allowed
           </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Corrective Action Taken</mat-label>
          <textarea
            matInput
            formControlName="correctiveAction"
            rows="4"
          ></textarea>
          <mat-error *ngIf="getMandatoryError('correctiveAction')">
  {{ getMandatoryError('correctiveAction') }}
</mat-error>
          <mat-error *ngIf=" deviationForm
                .get('deviationDetails.correctiveAction')?.hasError('specialCharacter')">
            Special characters are not allowed
           </mat-error>

        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="full-width">
          <mat-label>Impact And Risk Analysis</mat-label>
          <textarea
            matInput
            formControlName="impactAndRiskAnalysis"
            rows="4"
          ></textarea>
        </mat-form-field> -->

        <!-- <mat-form-field appearance="outline" class="full-width">
          <mat-label>Effective Check Details</mat-label>
          <textarea
            matInput
            formControlName="effectiveCheckDetails"
            rows="4"
          ></textarea>
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Investigation and Summary Conclusion </mat-label>
          <textarea
            matInput
            formControlName="investigationAndSummaryConclusion"
            rows="4"
          ></textarea>

          <mat-error
            *ngIf="getMandatoryError('investigationAndSummaryConclusion')"
          >
            {{ getMandatoryError("investigationAndSummaryConclusion") }}
          </mat-error>

                    <mat-error *ngIf=" deviationForm
                .get('deviationDetails.investigationAndSummaryConclusion')?.hasError('specialCharacter')">
            Special characters are not allowed
           </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>External Tracking Id</mat-label>
          <textarea
            matInput
            formControlName="externalTrackingId"
            rows="4"
          ></textarea>

          <!-- <mat-error
            *ngIf="getMandatoryError('externalTrackingId')"
          >
            {{ getMandatoryError("externalTrackingId") }}
          </mat-error> -->

            <!-- <mat-error *ngIf=" deviationForm
                .get('deviationDetails.investigationAndSummaryConclusion')?.hasError('specialCharacter')">
            Special characters are not allowed
           </mat-error> -->
        </mat-form-field>
      </div>

      <!-- Row 4 -->
      <div formGroupName="deviationDetails" class="form-row three-radio-row">
        <!-- Further Investigation -->
        <!-- <div class="radio-group">
          <label class="radio-title"> Further Investigation Required ? </label>
          <mat-radio-group formControlName="furtherInvestigationRequired">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div> -->

        <!-- CAPA -->
        <div class="radio-group">
          <label class="radio-title"> CAPA Required ? </label>
          <mat-radio-group formControlName="capaRequired">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Effective Check -->
        <!-- <div class="radio-group">
          <label class="radio-title"> Effective Check Required ? </label>
          <mat-radio-group formControlName="effectiveCheckRequired">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div> -->
      </div>

      <!-- Footer -->
      <div class="step-footer mt-2">
        <div class="footer-left">
          <!-- <button
            i18n="@@TMRunButton"
            type="button"
            (click)="cancel()"
            [style.border-color]="backgroundColorButton"
            class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: 0.3rem 1.6rem"
            [style.border-color]="backgroundColorButton"
          >
            Cancel
          </button> -->

            <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="cancel()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>


        </div>
        <div class="footer-right">
          <!-- <button
            id="saveBtn"
            i18n="@@TMRunButton"
            type="button"
            (click)="saveDevaitionDetail(stepper)"
            [style.background-color]="backgroundColorButton"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: 0.3rem 1.6rem"
          >
            Save & Next
          </button> -->

          <app-common-button
 
          label="Save & Next"
 
          title="Save & Next "
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="saveDevaitionDetail(stepper)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
		  

        </div>
      </div>
    </mat-step>

    <!-- STEP 2 -->
    <mat-step
      label="Root Cause"
      [editable]="!isFormOpen"
      [completed]="!isFormOpen"
    >
      <app-root-cause
        *ngIf="loadRootCause"
        [deviationId]="deviationId"
        [rootCauses]="rootCauses"
        (rootCausesChange)="rootCauses = $event"
        (formOpenChange)="isFormOpen = $event"
      >
      </app-root-cause>

      <div class="step-footer mt-2" *ngIf="!isFormOpen">
        <div class="footer-left">
          <!-- <button
            i18n="@@TMRunButton"
            type="button"
            (click)="back()"
            [style.border-color]="backgroundColorButton"
            class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: 0.3rem 1.6rem"
            [style.border-color]="backgroundColorButton"
          >
            Back
          </button> -->

           <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="back()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
        </div>

        <div class="footer-right">
          <!-- <button
            id="saveBtn"
            i18n="@@TMRunButton"
            type="button"
            (click)="next()"
            [style.background-color]="backgroundColorButton"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: 0.3rem 1.6rem"
          >
            Next
          </button> -->

        <app-common-button
 
          label="Next"
 
          title="Next "

          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="next()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
        </div>
      </div>
    </mat-step>

    <!-- STEP 3 -->
    <mat-step label="CAPA" [editable]="!isFormOpen">
      <app-capa
        *ngIf="loadCapa"
        [deviationId]="deviationId"
        [capas]="capas"
        (capasChange)="capas = $event"
        (capaValidityChange)="hasValidCapa = $event"
        (formOpenChange)="isFormOpen = $event"
      >
      </app-capa>

      <div class="step-footer mt-2" *ngIf="!isFormOpen">
        <div class="footer-left">
          <!-- <button
            i18n="@@TMRunButton"
            type="button"
            (click)="back()"
            [style.border-color]="backgroundColorButton"
            class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: 0.3rem 1.6rem"
            [style.border-color]="backgroundColorButton"
          >
            Back
          </button> -->

           <app-common-button
          label="Back"
          title="Back "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="back()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
          
        </div>

        <div class="footer-right">
          <!-- <button id="saveBtn" i18n="@@TMRunButton" type="button" (click)="next()" [style.background-color]="backgroundColorButton"
      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" style="padding: .3rem 1.6rem;">
      Save
    </button> -->
          <!-- <button
            id="saveBtn"
            i18n="@@TMRunButton"
            type="button"
            (click)="closeDeviation()"
            [style.background-color]="backgroundColorButton"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: 0.3rem 1.6rem"
          >
            Submit
          </button> -->

          <app-common-button
          label="Submit"
          title="Submit "
          [buttonId]="1111"
			    width="110px"
          [critical]="false"
          (clicked)="closeDeviation()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</form>
